import { GetReturnNote, GetCustomersByName, UpdateSearchedName, SelectCustomer, SaveReturnNote, UpdateValidationObject, ToggleShowCustomerModal, UpdateComment } from '../actions/actionTypes';
import API from '../../services/requestService';
import ENDPOINT from '../../services/endpoints';
import { showToast, showLoader } from './common';
import { TOAST_HEADER, MESSAGES } from '../../services/constants';
import { Dispatch } from 'redux';
import { ICustomer } from '../../shared/models/adminModels';
import { IReturnNote } from '../../shared/models/returnNoteModels';
import store from '..';
import { get } from 'lodash';
import moment from 'moment';

export const getReturnNote = (productType: number, col: number) => async (dispatch: Dispatch<any>) => {
  dispatch(showLoader(true));
  dispatch({
    type: GetReturnNote,
    payload: null
  });
  try {
    const { data: response }: any = await API.get(ENDPOINT.getReturnNote, {
      params: { productTypeId: productType }
    });
    dispatch(showLoader(false));
    if (response && response.isSuccess) {
      // get logged in user from store
      const loggedInUser = store.getState().auth.user;

      response.data.raisedByUserId = loggedInUser.id;
      response.data.raisedBy = loggedInUser.customerName;
      response.data.raisedByDate = moment().utc().format();

      return dispatch({
        type: GetReturnNote,
        payload: { ...response.data, productTypeID: productType, currentColPosition: col }
      })
    } else {
      dispatch({
        type: GetReturnNote,
        payload: null
      });
      return dispatch(showToast(TOAST_HEADER.ERROR, response.message));
    }
  } catch (e) {
    console.error('getReturnNote', e);
    dispatch(showLoader(false));
    return dispatch(showToast(TOAST_HEADER.ERROR, e.response.data));
  }
}

export const getReturnNoteById = (returnNoteId: string) => (dispatch: Dispatch<any>) => {
  return new Promise(async (resolve, reject) => {
    dispatch(showLoader(true));
    dispatch({
      type: GetReturnNote,
      payload: null
    });
    try {
      const { data: response }: any = await API.get(ENDPOINT.getReturnNoteById, {
        params: { returnNoteId }
      });
      dispatch(showLoader(false));
      if (response && response.isSuccess) {
        // get customer details
        response.data.message = response.message;
        dispatch({
          type: GetReturnNote,
          payload: { ...response.data }
        });
        return resolve(response.data.customerId);
      } else {
        dispatch({
          type: GetReturnNote,
          payload: null
        });
        dispatch(showToast(TOAST_HEADER.ERROR, response.message));
        return reject(response.message);
      }
    } catch (e) {
      console.error('getReturnNoteById', e);
      dispatch(showLoader(false));
      dispatch(showToast(TOAST_HEADER.ERROR, e.response.data));
      return reject(e);
    }
  })
}

export const changeReturnNoteObj = (returnNote: IReturnNote, validation?: any) => (dispatch: Dispatch<any>) => {
  returnNote.masterData = store.getState().returnNote.masterData;
  // if (validation) {
  //     dispatch(updateValidationObject(validation));
  // }
  return dispatch({
    type: GetReturnNote,
    payload: returnNote
  });
}

export const getCustomersByName = (searchName: string) => async (dispatch: Dispatch<any>) => {
  dispatch(showLoader(true));
  try {
    const { data: response }: any = await API.get(ENDPOINT.getCustomersByName, {
      params: { searchName }
    });
    dispatch(showLoader(false));
    return response && response.isSuccess
      ? dispatch({
        type: GetCustomersByName,
        payload: response.data
      })
      : dispatch(showToast(TOAST_HEADER.ERROR, response.message));

  } catch (e) {
    console.error('getCustomersByName', e);
    dispatch(showLoader(false));
    return dispatch(showToast(TOAST_HEADER.ERROR, e.response.data));
  }
}

export const clearCustomerList = () => (dispatch: Dispatch<any>) => {
  return dispatch({
    type: GetCustomersByName,
    payload: []
  });
}

export const updateSearchedName = (searchName: string) => (dispatch: Dispatch<any>) => {
  return dispatch({
    type: UpdateSearchedName,
    payload: searchName
  })
}

export const selectCustomer = (customer: ICustomer) => (dispatch: Dispatch<any>) => {
  const validations = store.getState().returnNote.validations;
  validations.selectedCustomer.errorMessage.required = '';
  dispatch({
    type: SelectCustomer,
    payload: customer
  });
  return dispatch(updateValidationObject(validations));
}


export const checkSerialNo = (serialNo: Number, returnNoteId) => (dispatch: Dispatch<any>) => {
  return new Promise(async (resolve, reject) => {
    // dispatch(showLoader(true));
    try {
      const { data: response }: any = await API.get(ENDPOINT.serialNoExist, {
        params: { serialNo, returnNoteId }
      });
      // dispatch(showLoader(false));
      // const validations = store.getState().returnNote.validations;
      // validations.serialNo.isValid = !response.data;
      // validations.serialNo.errorMessage.serialNoExist = response.data ? response.message : '';
      // dispatch(updateValidationObject(validations));
      resolve(response);
    } catch (e) {
      console.error('checkSerialNo', e);
      // dispatch(showLoader(false));
      dispatch(showToast(TOAST_HEADER.ERROR, e.response.data));
      reject(e);
    }
  });
}



export const saveReturnNote = (returnNote: IReturnNote) => (dispatch: Dispatch<any>) => {
  return new Promise(async (resolve, reject) => {
    dispatch(showLoader(true));
    try {
      // remove extra unnecessary attribute before request
      delete returnNote.commentsHistories;
      delete returnNote.raisedBy;

      const { data: response }: any = await API.post(ENDPOINT.saveReturnNote, returnNote);
      dispatch(showLoader(false));
      if (response && response.isSuccess) {
        dispatch({
          type: GetReturnNote,
          payload: null
        });
        dispatch({
          type: SaveReturnNote,
          payload: response.data
        });
        return resolve();
      } else {
        dispatch(showToast(TOAST_HEADER.ERROR, response.message));
        return reject(response.message);
      }
    } catch (e) {
      const error = get(e, 'response.data', 'Something went wrong!');
      console.error('getCustomersByName', e);
      dispatch(showLoader(false));
      dispatch(showToast(TOAST_HEADER.ERROR, error));
      return reject(error);
    }
  })
}

export const updateValidationObject = (object: any) => (dispatch: Dispatch<any>) => dispatch({
  type: UpdateValidationObject,
  payload: object
});

export const toggleShowCustomerModal = (value: boolean) => (dispatch: Dispatch<any>) => dispatch({
  type: ToggleShowCustomerModal,
  payload: value
})

export const updateComment = (data: any) => (dispatch: Dispatch<any>) => {
  return new Promise(async (resolve, reject) => {
    try {
      // call comment update API
      const { data: response }: any = await API.post(ENDPOINT.updateComment, data);

      if (!response.isSuccess) {
        dispatch(showToast(TOAST_HEADER.ERROR, response.message));
        return reject(false)
      }

      // get updated Comment data
      const { data: res }: any = await API.get(`${ENDPOINT.getCommentById}?commentHistoryId=${data.id}`);

      let commentsHistories = store.getState().returnNote.returnNote.commentsHistories;

      // change updated comment to comments array
      let commentIndex = commentsHistories.findIndex(item => item.id === data.id);
      commentsHistories[commentIndex].comments = res.data.comments;
      commentsHistories[commentIndex].updatedBy = res.data.updatedBy;
      commentsHistories[commentIndex].updatedDate = res.data.updatedDate;

      // update commentHistory array
      dispatch({
        type: UpdateComment,
        payload: commentsHistories
      })
      dispatch(showToast(TOAST_HEADER.SUCCESS, response.message));
      resolve(true)
    } catch (e) {
      console.error('updateComment', e);
      reject(false)
    }
  })
}

export const deleteComment = (data: any) => (dispatch: Dispatch<any>) => {
  return new Promise(async (resolve, reject) => {
    try {
      // call comment update API
      const { data: response }: any = await API.post(ENDPOINT.deleteComment, data);

      if (!response.isSuccess) {
        dispatch(showToast(TOAST_HEADER.ERROR, response.message));
        return reject(false)
      }

      let commentsHistories = store.getState().returnNote.returnNote.commentsHistories;
      // change updated comment to comments array

      let updatedCommentsHistories = commentsHistories.filter(item => item.id !== data.id);

      // update commentHistory array
      dispatch({
        type: UpdateComment,
        payload: updatedCommentsHistories
      })
      dispatch(showToast(TOAST_HEADER.SUCCESS, response.message));
      resolve(true)
    } catch (e) {
      console.error('deleteComment', e);
      reject(false)
      dispatch(showToast(TOAST_HEADER.ERROR, e.response.data));
    }
  })
}
